import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 'calc(100vh - 80px)',
        bgcolor: '#f5f6f7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <Paper
        sx={{
          width: '100%',
          textAlign: 'center',
          p: 6,
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          height: 'calc(100vh - 110px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: '#fef2f2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            mx: 'auto',
            mb: 3,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 30, color: '#ef4444' }} />
        </Box>

        <Typography variant="h3" fontWeight="bold !important" sx={{ mb: 4, color: '#333' }}>
          Access Denied
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 4, px: 2 }}>
          You don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ textTransform: 'none !important', borderColor: '#ddd', color: '#666' }}
          >
            Go back
          </Button>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/projects')}
            sx={{ textTransform: 'none !important', bgcolor: '#333', '&:hover': { bgcolor: '#555' } }}
          >
            Go to Projects
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AccessDenied;
